/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SecuredAllocationEnriched } from './SecuredAllocationEnriched';
import {
    SecuredAllocationEnrichedFromJSON,
    SecuredAllocationEnrichedFromJSONTyped,
    SecuredAllocationEnrichedToJSON,
} from './SecuredAllocationEnriched';

/**
 * 
 * @export
 * @interface SecuredAllocationPage
 */
export interface SecuredAllocationPage {
    /**
     * 
     * @type {Array<SecuredAllocationEnriched>}
     * @memberof SecuredAllocationPage
     */
    securedAllocation: Array<SecuredAllocationEnriched>;
    /**
     * 
     * @type {number}
     * @memberof SecuredAllocationPage
     */
    totalNr: number;
    /**
     * 
     * @type {string}
     * @memberof SecuredAllocationPage
     */
    asOfDate: string;
}

/**
 * Check if a given object implements the SecuredAllocationPage interface.
 */
export function instanceOfSecuredAllocationPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "securedAllocation" in value;
    isInstance = isInstance && "totalNr" in value;
    isInstance = isInstance && "asOfDate" in value;

    return isInstance;
}

export function SecuredAllocationPageFromJSON(json: any): SecuredAllocationPage {
    return SecuredAllocationPageFromJSONTyped(json, false);
}

export function SecuredAllocationPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecuredAllocationPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'securedAllocation': ((json['secured_allocation'] as Array<any>).map(SecuredAllocationEnrichedFromJSON)),
        'totalNr': json['total_nr'],
        'asOfDate': json['as_of_date'],
    };
}

export function SecuredAllocationPageToJSON(value?: SecuredAllocationPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'secured_allocation': ((value.securedAllocation as Array<any>).map(SecuredAllocationEnrichedToJSON)),
        'total_nr': value.totalNr,
        'as_of_date': value.asOfDate,
    };
}

